import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { IFireAgency, IFireAgencyForm } from 'src/models/fire-agency.model';
import { useFireAgencyContext } from 'src/contexts/fire-agency.context';
import Lang from 'src/libraries/language';
import { getFireAgencyStatus } from 'src/selectors/fire-agency.selector';
import { actionTypes } from 'src/ducks/fire-agency.duck';
import FireAgenciesForm from '../fire-agencies-form/fire-agencies-form.component';
import style from '../fire-agencies-list/fire-agencies-list.module.scss';

type IProp = {
  data: IFireAgency;
};

const FireAgenciesEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useFireAgencyContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(true);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IFireAgency> = {
    name: '',
    rate: 0,
    agencyId: 0,
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getFireAgencyStatus(state, actionTypes.FIRE_AGENCY_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IFireAgencyForm = {
        name: value.name,
        rate: value.rate,
      };
      const response = await actions.updatePUT(value.agencyId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FIRE_AGENCY_EDIT_SUCCESS,
            formData.name ? formData.name : value.name
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_MODIFY_FIRE_AGENCY}
      content={
        <div className={style.content}>
          <FireAgenciesForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FireAgenciesEdit;
